interface BusinessInfo {
  companyName: string;
  representative: string;
  businessNumber: string;
  bankName: string;
  accountNumber: string;
  accountHolder: string;
}

interface BusinessInfoFormProps {
  formData: BusinessInfo;
  onFormChange: (field: keyof BusinessInfo, value: string) => void;
  className?: string;
}

export function BusinessInfoForm({ 
  formData, 
  onFormChange, 
  className = '' 
}: BusinessInfoFormProps) {
  
  const handleInputChange = (field: keyof BusinessInfo, value: string) => {
    if (field === 'businessNumber' || field === 'accountNumber') {
      value = value.replace(/[^0-9]/g, '');
    }
    onFormChange(field, value);
  };

  return (
    <div className={`space-y-6 ${className}`}>
      {/* 업체명 */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          업체명
        </label>
        <input
          type="text"
          value={formData.companyName}
          onChange={(e) => handleInputChange('companyName', e.target.value)}
          placeholder="업체명을 입력해주세요"
          className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#51C854] placeholder:text-[#606060]"
        />
      </div>

      {/* 대표자명 */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          대표자명
        </label>
        <input
          type="text"
          value={formData.representative}
          onChange={(e) => handleInputChange('representative', e.target.value)}
          placeholder="대표자명을 입력해주세요"
          className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#51C854] placeholder:text-[#606060]"
        />
      </div>

      {/* 사업자번호 */}
      <div>
        <label className="block text-[18px] font-medium text-[#222222] mb-3">
          사업자번호
        </label>
        <input
          type="text"
          value={formData.businessNumber}
          onChange={(e) => handleInputChange('businessNumber', e.target.value)}
          placeholder="사업자번호를 입력해주세요"
          className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#51C854] placeholder:text-[#606060]"
        />
      </div>

      {/* 정산 정보 섹션 */}
      <div className="pt-6 border-t border-gray-200">
        <h3 className="text-[20px] font-semibold text-[#222222] mb-6">정산 정보</h3>
        
        {/* 은행명 */}
        <div className="mb-6">
          <label className="block text-[18px] font-medium text-[#222222] mb-3">
            은행명
          </label>
          <input
            type="text"
            value={formData.bankName}
            onChange={(e) => handleInputChange('bankName', e.target.value)}
            placeholder="은행명을 입력해주세요"
            className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#51C854] placeholder:text-[#606060]"
          />
        </div>

        {/* 계좌번호 */}
        <div className="mb-6">
          <label className="block text-[18px] font-medium text-[#222222] mb-3">
            계좌번호
          </label>
          <input
            type="text"
            value={formData.accountNumber}
            onChange={(e) => handleInputChange('accountNumber', e.target.value)}
            placeholder="계좌번호를 입력해주세요"
            className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#51C854] placeholder:text-[#606060]"
          />
        </div>

        {/* 예금주 */}
        <div>
          <label className="block text-[18px] font-medium text-[#222222] mb-3">
            예금주
          </label>
          <input
            type="text"
            value={formData.accountHolder}
            onChange={(e) => handleInputChange('accountHolder', e.target.value)}
            placeholder="예금주를 입력해주세요"
            className="w-full h-[48px] px-5 text-[18px] border-[1.5px] border-[#979797] rounded-[12px] focus:outline-none focus:border-[#51C854] placeholder:text-[#606060]"
          />
        </div>
      </div>
    </div>
  );
}